import submissionsApi from './submissions-api';

export default submissionsApi;
